module.exports = __webpack_public_path__ + "img/shejiaoguize.987788b3.png";